import { DetailView, FormView, SchemaItem, Table } from "@data-root/types";
import { Tabs as _Tabs, TabsProps as _TabsProps, theme } from "antd";
import { FC, useCallback, useMemo, useState } from "react";
import { useTabs } from "../hooks/useTabs";
import { useNavigation } from "@data-root/react";
import StickyBox from "react-sticky-box";

interface TabsProps {
  table: Table;
  view: FormView | DetailView;
  resolver: (items: SchemaItem[]) => FC;
}

export const Tabs: FC<TabsProps> = ({ table, view, resolver }) => {
  const { navigation } = useNavigation();
  const { tabIds, tabNames, tabItems } = useTabs(table, view.itemGroups);

  const [defaultTabId] = useState(navigation.getParam("tabId") ?? undefined);

  const components = useMemo(() => {
    return tabItems.map(resolver);
  }, [resolver, tabItems]);

  const onTabClick = useCallback(
    (key: string) => {
      navigation.setParams({ tabId: key });
    },
    [navigation]
  );

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const renderTabBar: _TabsProps["renderTabBar"] = (props, DefaultTabBar) => (
    <StickyBox style={{ zIndex: 1 }}>
      <DefaultTabBar {...props} style={{ background: colorBgContainer }} />
    </StickyBox>
  );

  return (
    <_Tabs
      id={`${view.id}-tabs`}
      type="card"
      renderTabBar={renderTabBar}
      defaultActiveKey={defaultTabId}
      onTabClick={onTabClick}
      items={tabIds.map((id, i) => ({
        key: id,
        label: tabNames[i],
        children: components[i]({}),
      }))}
      destroyInactiveTabPane={false}
    />
  );
};
